var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'underscore', 'mixin', 'core', 'app-common/component/loader', 'app-common/component/notification', 'app-common/component/validation', 'app-common/component/api-call', 'app-common/view/dialog', 'app-common/template/email-password.htm', 'common/lib/json2', 'common/lib/forms/jquery.placeholder'], function($, _, mixin, core, loader, NotificationSupport, validation, apiCall, DialogView, landingTemplate) {
  var EmailPasswordFormView;
  return EmailPasswordFormView = (function(_super) {

    __extends(EmailPasswordFormView, _super);

    function EmailPasswordFormView() {
      EmailPasswordFormView.__super__.constructor.apply(this, arguments);
    }

    EmailPasswordFormView.prototype.notificationSelector = function() {
      return '#dialog-window .notification-area';
    };

    EmailPasswordFormView.prototype.emailValidator = null;

    EmailPasswordFormView.prototype.passwordValidator = null;

    EmailPasswordFormView.prototype.initialize = function(options, params) {
      var _ref;
      if ((_ref = this.model) == null) {
        this.model = core.getCurrentClient();
      }
      this.render(_.template(landingTemplate, {
        email: this.model.get('email')
      }));
      this.initEmail();
      this.initPassword();
      $('#email-form input, #password-form input').placeholder();
      return this.setNotifications({
        email_change_sent: {
          type: 'warning',
          text: 'Thank you! Your new email address has been submitted, and we\'ve sent you a confirmation message. Please check your email inbox and follow the instructions in the message to complete the change.'
        },
        email_change_success: {
          type: 'success',
          text: 'Thank you! Your e-mail address has been updated.'
        },
        email_change_failed: {
          type: 'error',
          text: 'Something went wrong, and we could not update your email.'
        },
        password_change_success: {
          type: 'success',
          text: 'Your password was successfully updated.'
        },
        password_change_error: {
          type: 'error',
          text: 'Something went wrong, and we could not update your password.'
        }
      });
    };

    EmailPasswordFormView.prototype.remove = function() {
      this.hideNotifications();
      return EmailPasswordFormView.__super__.remove.apply(this, arguments);
    };

    EmailPasswordFormView.prototype.saveEmail = function() {
      var data, promise,
        _this = this;
      loader.init({
        dialog: true
      });
      data = {
        newEmail: $('#email').val(),
        password: $('#password').val()
      };
      promise = apiCall('person', "change_email/" + (this.model.get('id')), 'POST', data);
      promise.always(function() {
        return loader.hide();
      });
      promise.done(function() {
        $('.email-field').val('');
        _this.emailValidator.resetForm();
        $('#save-email').prop('disabled', true);
        return _this.showNotification('email_change_sent');
      });
      return promise.fail(function() {
        return _this.showNotification('email_change_failed');
      });
    };

    EmailPasswordFormView.prototype.savePassword = function() {
      var data, promise,
        _this = this;
      loader.init({
        dialog: true
      });
      data = {
        currentPassword: $('#current-password').val(),
        newPassword: $('#new-password').val()
      };
      promise = apiCall('person', "change_password/" + (this.model.get('id')), 'POST', data);
      promise.always(function() {
        return loader.hide();
      });
      promise.done(function() {
        $('.password-field').val('');
        _this.passwordValidator.resetForm();
        $('#save-password').prop('disabled', true);
        return _this.showNotification('password_change_success');
      });
      return promise.fail(function() {
        return _this.showNotification('password_change_error');
      });
    };

    EmailPasswordFormView.prototype.initPassword = function() {
      var _this = this;
      validation.addRules({
        'current-password': {
          requiredWP: true,
          remote: function() {
            return {
              url: '/base/validateCredentials.action',
              type: 'POST',
              contentType: 'application/json; charset=utf-8',
              dataType: 'json',
              data: JSON.stringify({
                password: $('#current-password').val()
              })
            };
          }
        },
        'new-password': {
          requiredWP: true
        },
        'confirm-password': {
          requiredWP: true,
          equalTo: '#new-password'
        }
      });
      validation.addMessages({
        'current-password': {
          remote: 'Incorrect password or email not validated'
        },
        'confirm-password': {
          equalTo: 'Passwords do not match'
        }
      });
      this.passwordValidator = validation.init($('#password-form'));
      return $('#password-form').submit(function(e) {
        e.preventDefault();
        if ($('#password-form').valid()) {
          return _this.savePassword();
        }
      });
    };

    EmailPasswordFormView.prototype.initEmail = function() {
      var _this = this;
      validation.addRules({
        'email': {
          requiredWP: true,
          email: true,
          uniqEmail: true
        },
        'confirm-email': {
          requiredWP: true,
          equalTo: '#email'
        },
        'password': {
          requiredWP: true
        }
      });
      validation.addMessages({
        'email': {
          uniqEmail: 'An account with this email address already exists'
        },
        'confirm-email': {
          equalTo: 'Enter the same value again'
        }
      });
      this.emailValidator = validation.init($('#email-form'));
      return $('#email-form').submit(function(e) {
        e.preventDefault();
        if ($('#email-form').valid() && $('#email').val() !== _this.model.get('email')) {
          return _this.saveEmail();
        }
      });
    };

    return EmailPasswordFormView;

  })(mixin.of(DialogView, NotificationSupport));
});
